export default __webpack_public_path__ + "static/media/Animals_22.fc97d08a.png";